import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-stop",
  "use": "icon-stop-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-stop\">\n  <defs><style type=\"text/css\">\n    </style>\n  </defs>\n  <path d=\"M896.215 874.19c0 17.51-14.508 32.018-32.018 32.018L159.811 906.208c-17.51 0-32.018-14.508-32.018-32.018L127.793 169.804c0-17.51 14.508-32.018 32.018-32.018l704.386 0c17.51 0 32.018 14.508 32.018 32.018L896.215 874.19z\" p-id=\"2572\">\n  </path>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol